import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  menuItem: {
    textTransform: 'capitalize',
  },
  capitalizeLabel: {
    textTransform: 'capitalize',
  },
  itemIcon: {
    minWidth: 'fit-content',
    marginRight: theme.spacing(1),
  },
  geoEventOption: {
    display: 'flex',
    height: 38,
  },
  geoEventIcon: {
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(1.5),
  },
}));
